var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeActive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.497,
    height: 25.969,
    viewBox: "0 0 26.497 25.969",
    style: {
      fill: "white"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#2A7DE1;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-839.031 -205.245)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M865.528,215.96v12.846a2.41,2.41,0,0,1-2.409,2.409h-4.879a2.41,2.41,0,0,1-2.409-2.409v-4.68a3.552,3.552,0,0,0-3.552-3.552h0a3.552,3.552,0,0,0-3.552,3.552v4.68a2.41,2.41,0,0,1-2.409,2.409H841.44a2.409,2.409,0,0,1-2.409-2.409V215.96a2.41,2.41,0,0,1,.943-1.911l10.84-8.307a2.412,2.412,0,0,1,2.931,0l10.84,8.307A2.407,2.407,0,0,1,865.528,215.96Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeActive);
export default __webpack_public_path__ + "static/media/homeActive.8147e0eed04b449eded044c9e7fbbc62.svg";
export { ForwardRef as ReactComponent };